import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const ModalContext = createContext(undefined);
export function ModalContextProvider({ initialView, children, onClose }) {
    const [stack, setStack] = useState([initialView]);
    const push = (view) => setStack(current => {
        const existingIndex = current.findIndex(item => item.id === view.id);
        if (existingIndex !== -1) {
            const next = [...current];
            next[existingIndex] = view;
            return next;
        }
        return [view, ...current];
    });
    const pop = () => setStack(current => current.slice(1));
    const getVisibleView = () => stack[0] ?? null;
    return (_jsx(ModalContext.Provider, { value: {
            close: onClose,
            stack,
            push,
            getVisibleView,
            initialView,
            pop,
        }, children: children }));
}
export function useModal(optional) {
    const context = useContext(ModalContext);
    if (!context && !optional) {
        throw new Error('useModal must be used within a Modal.Root');
    }
    return context;
}
